import { useState } from "react";

import Modal from "../Modal";
import HistorialLista from "./HistorialLista";

/* import buscarConcesionarioPorSeriePlacas from "../../helpers/concesionario/buscarConcesionarioPorSeriePlacas"; */
/* import buscarConcesionarioPorIdConcesion from "../../helpers/concesionario/buscarConcesionarioPorIdConcesion"; */
import mensajePreventivo from "../../helpers/mensajes/mensajePreventivo";
import obtenerPolizaPorIdPoliza  from "../../helpers/poliza/obtenerPolizaPorIdPoliza";
import VerificarUsuario from "../../helpers/usuario/verificarUsuario";

import obtener from "../../helpers/contribuyente/contribuyente/obtener";
import obtenerPorIdConcesion from "../../helpers/contribuyente/contribuyente/obtenerPorIdConcesion";
import obtenerPorPlacas from "../../helpers/contribuyente/contribuyente/obtenerPorPlacas";

const Historial = ({ data, setData, catalogos, folio, setFolio }) => {
    
    /* console.clear(); */
    VerificarUsuario();
    const { contribuyente, concesionActual } = data;
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [contribuyentes, setContribuyentes] = useState([]);

    const toggleModal = () => setModalIsOpen(!isModalOpen);


    if (data.historial !== undefined) if (data.historial.length === 0) mensajePreventivo("Historial vacío", 1000);

    return (
        <div className="contenedorMain">

            <div className="formulario">
                <div className="boxRow">
                    {/* Número de póliza (Folio) */}
                    <div className="boxColumn">
                        <label className="lblCampo">Folio</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtenerPolizaPorIdPoliza(folio, setData, data)}>
                            <input className="actions" type="text"
                                value={folio}
                                onChange={e => setFolio(e.target.value.toUpperCase())}
                            />
                            <div className="actions">
                                <button onClick={() => obtenerPolizaPorIdPoliza(folio, setData, data)}>
                                    <span className="material-icons">search</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Nombre del contribuyente */}
                    <div className="boxColumn flex3">
                        <label className="lblCampo" id="lblContribuyente">Contribuyente</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                            {/* Nombre */}
                            <input className="actions" id="inputNombre" type="text" placeholder="Nombre(s)"
                                value={contribuyente?.nombre === undefined ? "" : contribuyente?.nombre.toUpperCase()}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, nombre: e.target.value.toUpperCase() } })}
                            />

                            {/* Apellido paterno */}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoP" type="text" placeholder="Apellido Paterno"
                                    value={contribuyente?.apellidoPaterno === undefined ? "" : contribuyente?.apellidoPaterno.toUpperCase()}
                                    onChange={e => setData({ ...data, contribuyente: { ...contribuyente, apellidoPaterno: e.target.value.toUpperCase() } })}
                                />
                            )}

                            {/* Apellido materno */}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoM" type="text" placeholder="Apellido Materno"
                                    value={contribuyente?.apellidoMaterno === undefined ? "" : contribuyente?.apellidoMaterno.toUpperCase()}
                                    onChange={e => setData({ ...data, contribuyente: { ...contribuyente, apellidoMaterno: e.target.value.toUpperCase() } })}
                                />
                            )}

                            {/* Buscar contribuyente */}
                            <div className="actions">
                                <button onClick={() => obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                                    <span className="material-symbols-outlined">
                                        search
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* RFC */}
                    <div className="boxColumn">
                        <label className="lblCampo" >RFC</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                            <input className="actions" type="text"
                                value={contribuyente?.rfc === undefined ? "" : contribuyente?.rfc}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, rfc: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions">
                                <button onClick={() => obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                                    <span className="material-symbols-outlined">
                                        search
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="boxRow">
                    {/* Número de placas */}
                    <div className="boxColumn">
                        <label className="lblCampo" >No. Placas</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtenerPorPlacas(data, setData)}>
                            <input className="actions" type="text"
                                value={concesionActual?.seriePlaca === undefined ? "" : concesionActual?.seriePlaca.toUpperCase()}
                                onChange={e => setData({ ...data, concesionActual: { ...concesionActual, seriePlaca: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions" onClick={() => obtenerPorPlacas(data, setData)}>
                                <button><span className="material-symbols-outlined">
                                    search
                                </span></button>
                            </div>
                        </div>
                    </div>

                    {/* Número de concesión */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Concesión</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtenerPorIdConcesion(data, setData)}>
                            <input className="actions" type="text"
                                value={concesionActual?.idConcesion === undefined ? "" : concesionActual?.idConcesion}
                                onChange={e => setData({ ...data, concesionActual: { ...concesionActual, idConcesion: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions" onClick={() => obtenerPorIdConcesion(data, setData)}>
                                <button><span className="material-symbols-outlined">
                                    search
                                </span></button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Observaciones */}
                <div className="boxRow">
                    <div className="boxColumn">
                        <label className="lblCampo" >Observaciones</label>
                        <div className="search-bar-textarea">
                            <textarea name="textarea" rows="3" cols="1"
                                value={concesionActual?.observaciones === undefined ? "" : concesionActual?.observaciones.toUpperCase()}
                                onChange={e => setData({ ...data, concesionActual: { ...concesionActual, observaciones: e.target.value.toUpperCase() } })}
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>

            {isModalOpen && <Modal onRequestClose={toggleModal} contribuyentes={contribuyentes} setData={setData} />}

            <HistorialLista data={data} catalogos={catalogos} />
        </div>
    )
}

export default Historial;